import { useCallback, useMemo, useState } from "react";
import useStateRef from "react-usestateref";
import { createUUID } from "../common";

export interface ValidationItem {
    id: string;
    isValid: boolean;
    uuid?: string;
}

/**
 * Tracks validity across a group of fields and reports consolidated state.
 * @returns Tuple of overall validity, an update helper, and registration function.
 */
export function useValidationGroup() {

    const [_id] = useMemo(() => [createUUID()], []);
    const [_index, setIndex] = useState<ValidationItem[]>([]);
    const [_valid, setValid] = useState<boolean>(false);

    /**
     * Registers validation items so their state contributes to the group result.
     * @param items - Collection of validation items with initial state.
     */
    const register = (items: ValidationItem[]) => {
        let index = [..._index]
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            let existing = index.find(x => x.id === item.id);
            if (!existing) {
                index.push({ ...item, uuid: createUUID() });
            } else {
                index[i].isValid = item.isValid;
            }
            setIndex(index);
        }


        let allValid = index.every(x => x.isValid);
       setValid(allValid);
    }

    /**
     * Updates the validity of a specific registered field and recalculates group state.
     * @param id - Identifier for the validation item.
     * @param isValid - Latest validity flag.
     */
    const update = useCallback((id: string, isValid: boolean) => {
        //console.log(`Updating validation item ${id} to ${isValid}`);
        let items = [..._index];
        let index = items.findIndex(x => x.id === id);
        if (index >= 0) {
            items[index].isValid = isValid;
        }
        setIndex(items);
     
        let allValid = items.every(x => x.isValid);
        setValid(allValid);
        
    }, [_index]);




    return [_valid, update, register] as const;

}